import {httpClient} from "@/requesters/httpClient";
import {parameters} from "@/parameters";

export const getBusinessUnits = async () => {
    return await httpClient.get(`${parameters.refUrl}/businessunits`)
        .then((response) => {
            let businessUnitsList = [];
            for (const businessUnit of response.data) {
                businessUnitsList.push({
                    'id': businessUnit.thirdId,
                    'name': businessUnit.name,
                    'countryCode': businessUnit.countryCode
                })
            }

            return businessUnitsList;
        })
        .catch((error) => {
            throw error;
        });
};

export const getItemCategories = async () => {
    return await httpClient.get(`${parameters.refUrl}/itemCategories`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            // eslint-disable-next-line no-console
            throw error;
        });
};

export const getTenders = async () => {

    return await httpClient.get(`${parameters.refUrl}/tenders`)
        .then((response) => {
            let tendersList = [];
            for (const tender of response.data){
                tendersList.push({
                    'code': tender.tenderCode,
                    'type': 'DKT:' + tender.tenderType
                })
            }
            return tendersList;
        })
};